module.exports = __webpack_public_path__ + "img/new_caledonia.d1ab85c.webp";